<template>
  <icon-arrow-left v-if="showArrow" v-show="beforeWidth" class="prev arrow" @click="handleScrollTo('left')" />

  <div ref="containerRef" class="scrollable-container" :class="{ showArrowMask: showArrowMask }">
    <div ref="contentRef" @scroll="handleScroll" class="scrollable-content">
      <div ref="elementsRef" class="scrollable-elements">
        <slot></slot>
      </div>
    </div>
  </div>

  <icon-arrow-right v-if="showArrow" v-show="afterWidth" class="next arrow" @click="handleScrollTo('right')" />
</template>

<script setup>
const props = defineProps({
  showArrow: {
    type: Boolean,
    default: true
  },
  showArrowMask: {
    type: Boolean,
    default: true,
  }
  // background: {
  //   type: String,
  //   default: '#F4F5F6'
  // }
})


// const { background } = props
const containerRef = ref(null);
const contentRef = ref(null);

const beforeWidth = ref(0)
const afterWidth = ref(0)


const isDragging = ref(false);
const initialX = ref(0);
const scrollLeft = ref(0);
const contentWidth = ref(0);
const containerWidth = ref(0);

const handleMouseDown = (event) => {
  contentRef.value.style.scrollBehavior = 'unset'
  isDragging.value = true;
  initialX.value = event.clientX;
  scrollLeft.value = contentRef.value.scrollLeft;
  event.preventDefault();
  document.addEventListener('mousemove', handleMouseMove);
};

const handleMouseMove = (event) => {
  if (isDragging.value) {
    contentRef.value.style.pointerEvents = 'none'
    const delta = event.clientX - initialX.value;
    const newScrollLeft = Math.max(0, Math.min(scrollLeft.value - delta, contentWidth.value - containerWidth.value));
    contentRef.value.scrollLeft = -delta + scrollLeft.value;
  }
};

const handleMouseUp = () => {
  contentRef.value.style.pointerEvents = null
  isDragging.value = false;
  document.removeEventListener('mousemove', handleMouseMove);
};

const elementsRef = ref(null)

const handleScroll = (e) => {
  const scrollLeft = e.target.scrollLeft
  const offsetWidth = e.target.offsetWidth

  if (scrollLeft <= 0) {
    // console.log("右边")
    beforeWidth.value = 0
    afterWidth.value = '100px'
    return
  }

  if (scrollLeft > 0 && scrollLeft + offsetWidth + 10 < elementsRef.value.offsetWidth) {
    // console.log("两边")
    beforeWidth.value = '100px'
    afterWidth.value = '100px'
    return
  }

  if (scrollLeft > 0 && scrollLeft + offsetWidth + 10 >= elementsRef.value.offsetWidth) {
    // console.log("左边")
    beforeWidth.value = '100px'
    afterWidth.value = 0
    return
  }
}

const handleScrollTo = (pos) => {
  contentRef.value.style.scrollBehavior = 'smooth'
  contentRef.value.scrollLeft += pos === 'left' ? -200 : 200;
};

// 判断是否需要显示箭头
const arrowVisible = () => {
  const contentWidth = contentRef.value.offsetWidth
  const elementsWidth = elementsRef.value.offsetWidth

  if (contentWidth < elementsWidth) {
    afterWidth.value = '100px'
  } else {
    afterWidth.value = 0
  }
}

onMounted(() => {
  arrowVisible()
  if (contentRef.value) {
    contentRef.value.addEventListener('mousedown', handleMouseDown);
    contentRef.value.addEventListener('mouseup', handleMouseUp);
  }
  document.addEventListener('mouseup', handleMouseUp);
  window.addEventListener('resize', arrowVisible)
})

onUnmounted(() => {
  if (contentRef.value) {
    contentRef.value.removeEventListener('mousedown', handleMouseDown);
    contentRef.value.removeEventListener('mouseup', handleMouseUp);
  }
  document.removeEventListener('mouseup', handleMouseUp);
  window.removeEventListener('resize', arrowVisible)
});
</script>

<style scoped lang="scss">
div::-webkit-scrollbar {
  display: none;
}

.scrollable-container {
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  height: 100%;
}

.scrollable-content {
  overflow-x: scroll;
  overflow-y: hidden;
  height: 100%;
  // scroll-behavior: smooth;
}

.scrollable-elements {
  display: flex;
  white-space: nowrap;
  height: 100%;
  align-items: center;
  width: fit-content;
  gap: 15px;
}

.scrollable-container::before,
.scrollable-container::after {
  bottom: 0;
  content: "";
  display: block;
  pointer-events: none;
  position: absolute;
  top: 0;
  transition: opacity .2s ease-in-out;
  z-index: 1;
}

.scrollable-container.showArrowMask::after {
  background: linear-gradient(90deg,
      hsla(0, 0%, 100%, 0) 0,
      #f2f3f5 99%,
      #f2f3f5);
  right: 0;
}

.scrollable-container::after {
  width: v-bind(afterWidth);
}

.scrollable-container::before {
  width: v-bind(beforeWidth);
}

.scrollable-container.showArrowMask::before {
  background: linear-gradient(270deg,
      hsla(0, 0%, 100%, 0) 0,
      #f2f3f5 99%,
      #f2f3f5);
  left: 0;
}

.arrow {
  color: #707177;
  height: 34px;
  width: 34px;
  // border: 1px solid;
  padding: 10px;
  cursor: pointer;
  user-select: none;
}
</style>
